// Article #6 — Should You Replace Pool Tile, Coping, and Decking During
// Resurfacing? The visible FAQ section and the FAQPage schema both read from
// this single array, so they always match exactly.
export const FAQS_REPLACE_TILE_COPING_DECKING: {
  question: string;
  answer: string;
}[] = [
  {
    question: "Do I have to replace pool tile when resurfacing?",
    answer:
      "No. Existing waterline tile may sometimes remain when it is securely bonded, intact, compatible with the resurfacing work, and acceptable to the homeowner. Loose, cracked, missing, deteriorated, or incompatible tile may justify repair, replacement, or further evaluation.",
  },
  {
    question: "Should pool coping always be replaced during resurfacing?",
    answer:
      "No. Sound and stable coping may be kept. Replacement may deserve consideration when coping units move, crack, separate, create unsafe edges, conflict with planned deck work, or cannot be integrated appropriately with the new tile and interior finish.",
  },
  {
    question: "Does resurfacing a pool require replacing the deck?",
    answer:
      "No. Pool resurfacing addresses the submerged interior finish. The surrounding deck is a separate component. Its condition, drainage, movement, appearance, material compatibility, and the homeowner\u2019s broader goals determine whether it should remain, be repaired, or be replaced.",
  },
  {
    question:
      "Is it less disruptive to replace tile and coping while resurfacing?",
    answer:
      "Coordinating the work may reduce duplicated draining, demolition, access, or protection requirements, but that does not mean every component should automatically be replaced. The practical benefit depends on the condition of the existing materials and the final project scope.",
  },
  {
    question: "Can only part of a pool deck be repaired?",
    answer:
      "Sometimes. Localized repairs may be appropriate when the surrounding deck remains stable and compatible material is available. Widespread movement, recurring cracking, drainage concerns, or significant material mismatch may make a larger scope worth evaluating.",
  },
  {
    question:
      "Can photographs show whether coping or deck cracks are structural?",
    answer:
      "No. Photographs can document the location and visible pattern, but they usually cannot establish the underlying cause, depth, movement, or severity. Cracks associated with settlement, movement, water loss, or recurring failure should be evaluated under appropriate on-site conditions.",
  },
  {
    question: "Should pool materials match exactly?",
    answer:
      "They do not need to be identical, but the interior finish, waterline tile, coping, deck, home exterior, and landscaping should relate intentionally. Reviewing physical samples together helps prevent individually attractive materials from competing once installed.",
  },
  {
    question: "What should a combined pool-remodeling proposal include?",
    answer:
      "It should clearly identify what will remain, what will be removed, preparation and repair responsibilities, exact material selections, installation sequence, transition details, filling and startup responsibilities, cleanup, exclusions, and how newly discovered conditions or requested changes will be handled.",
  },
];

export const TOC_REPLACE_TILE_COPING_DECKING = [
  { id: "the-short-answer", title: "The Short Answer" },
  {
    id: "four-separate-decisions-not-one-automatic-package",
    title: "Four Separate Decisions, Not One Automatic Package",
  },
  {
    id: "when-pool-tile-may-need-replacement",
    title: "When Pool Tile May Need Replacement",
  },
  {
    id: "when-existing-pool-tile-may-be-kept",
    title: "When Existing Pool Tile May Be Kept",
  },
  {
    id: "when-pool-coping-may-need-replacement",
    title: "When Pool Coping May Need Replacement",
  },
  {
    id: "when-existing-coping-may-be-kept",
    title: "When Existing Coping May Be Kept",
  },
  {
    id: "does-the-pool-deck-need-to-be-replaced",
    title: "Does the Pool Deck Need to Be Replaced?",
  },
  {
    id: "repairing-part-of-a-deck-vs-replacing-the-entire-deck",
    title: "Repairing Part of a Deck vs. Replacing the Entire Deck",
  },
  {
    id: "why-sequencing-matters-during-a-combined-project",
    title: "Why Sequencing Matters During a Combined Project",
  },
  {
    id: "how-to-coordinate-the-finish-tile-coping-and-deck",
    title: "How to Coordinate the Finish, Tile, Coping, and Deck",
  },
  {
    id: "a-practical-keep-repair-replace-or-evaluate-framework",
    title: "A Practical Keep, Repair, Replace, or Evaluate Framework",
  },
  {
    id: "questions-to-ask-before-finalizing-the-scope",
    title: "Questions to Ask Before Finalizing the Scope",
  },
  {
    id: "frequently-asked-questions",
    title: "Frequently Asked Questions",
  },
];
